import React from "react";
import "./style.css";

const ProjectStatusCard = ({ bgColor, title, count, icon, onClick }) => {
  return (
    <div
      className="card-container"
      style={{ background: bgColor }}
      onClick={onClick}
    >
      <div className="content-left">
        <div className="title">{title}</div>
        <div className="count">{count}</div>
      </div>
      <div className="icon">
        <img src={icon} alt="icon" />
      </div>
    </div>
  );
};

export default ProjectStatusCard;
